import(/* webpackMode: "eager" */ "/github/workspace/app/global-error.tsx");
